import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useDispatch } from "react-redux";
import { setStepperDisable } from "../../redux/slices/userSlice";
import Swal from "sweetalert2";

export default function Hyperverge() {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { selfieHypervergeResult } = new AfterOnboardAPI();

  const startHypervergeResult = async () => {
    try {
      handleShowContextualLoader("Verifying your Selfie...");
      const response = await selfieHypervergeResult();
      const status = response?.data?.status;

      await new Promise((res) => setTimeout(res, 3000));

      if (status == "auto_approved") {
        navigate("/term-condition");
      } else if (status == "auto_declined") {
        navigate("/home");
      } else if (status == "user_cancelled") {
        navigate("/selfie-verification");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error starting Hyperverge result:", error);
      Swal.fire({
        icon: "error",
        text: "Something went wrong",
      });
      await new Promise((res) => setTimeout(res, 3000));
      navigate("/dashboard");
    } finally {
      handlehideContextualLoader();
      dispatch(setStepperDisable(false));
    }
  };

  useEffect(() => {
    startHypervergeResult();
  }, []);

  return null;
}
